export const constants = Object.freeze({
    MCFA: "MCFA",
    MCFE: "MCFE",
    MCFS: "MCFS",
    UCA: "UCA",
    INPUT_FILE_TYPES: {
        CSV: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    },
    CATEGORY_CONTENT_TYPES: {
        RELATED_DOCUMENT: "RelatedDocumentPublished",
        INCLUDE_PART: "IncludeIndividualPartPublished",
        EXCLUDE_PART: "ExcludeIndividualPartPublished",
        PIC_CODE: "PicCodePublished",
        SPEC: "SpecPublished",
        MARKETING_TEXT: "MarketingTextPublished",
        SEE_ALSO: "SeeAlsoPublished",
        KIT: "KitPublished"
        
    },
    CATEGORY_FACET_PAGE_SIZE: 10,
    KEY_CODES: {
        E: 69
    },
    SIZES: {
        SMALL: 0,
        MED: 1,
        LARGE: 2
    },
    ONE_MEGABYTE: 1048576,
    MAX_AUTH_MASK: 31,
    USER_SETTINGS:{
        COLLAPSE_ALL_PART_DESCRIPTIONS: {
            Name: "Collapse All Part Descriptions",
            DefaultValue: false
        },
        PART_SEARCH_RESULT_DEFAULT_SORT:{
            Name: "Part Search Result Default Sort",
            DefaultValue: ""
        },
        GRID_VIEW_DEFAULT:{
            Name: "Grid View Default",
            DefaultValue: false
        },
        SHOW_SIDE_CART:{
            Name: "Show Side Cart",
            DefaultValue: true 
        },
        TMS_COMPACT_VIEW_DEFAULT:{
            Name: "TMS Compact View Default",
            DefaultValue: false
        }
    },
    USER_SETTINGS_TMS:{
        COLLAPSE_ALL_PART_DESCRIPTIONS_TMS: {
            Name: "Collapse All Part Descriptions",
            DefaultValue: false
        },
        PART_SEARCH_RESULT_DEFAULT_SORT_TMS:{
            Name: "Part Search Result Default Sort",
            DefaultValue: ""
        }
    },
    SORT_BY_OPTIONS: [
        { value: "", displayText: "-- Sort Results By --", sortKey: "", sortDirection: "Ascending" },
        { value: "dealerNetPriceAsc", displayText: "Dealer Net Price (Low to High)", sortKey: "dealerNetPrice", sortDirection: "Ascending" },
        { value: "dealerNetPriceDesc", displayText: "Dealer Net Price (High to Low)", sortKey: "dealerNetPrice", sortDirection: "Descending" },
        { value: "fleetListPriceAsc", displayText: "Fleet List Price (Low to High)", sortKey: "fleetListPrice", sortDirection: "Ascending"},
        { value: "fleetListPriceDesc", displayText: "Fleet List Price (High to Low)", sortKey: "fleetListPrice", sortDirection: "Descending"},
        { value: "descriptionAsc", displayText: "Alphabetical (A to Z)", sortKey: "descriptionKeyword", sortDirection: "Ascending"},
        { value: "descriptionDesc", displayText: "Alphabetical (Z to A)", sortKey: "descriptionKeyword", sortDirection: "Descending"},
        { value: "salesVolumeDesc", displayText: "Popularity", sortKey: "salesVolume", sortDirection: "Descending" },
    ],
    RESULTS_PER_PAGE: [
        { value: 10, displayText: "10" },
        { value: 25, displayText: "25" },
        { value: 50, displayText: "50" },
        { value: 100, displayText: "100" },
    ],
    FEATURE_NAMES: {
        UNALLOCATED_PRODUCTS: "Unallocated Products",
        OFFLINE_ORDER_PROCESSING: "Offline Order Processing",
        MLE_INVOICE_PRINTING: "Mle Invoice Printing",
        ORDERS_DISABLED: "Orders Disabled",
        SHOW_PRIVACY_FOOTER: "Show Privacy Footer",
        WAREHOUSE_LEAD_TIMES: "Warehouse Lead Times",
        SHOW_IL_WAREHOUSE: "ALCES3 IL01 AVAILABLE",
        DOCUMENTS_LIBRARY_ENABLED: "Documents Library Enabled",
        EMERGENCY_FIXED_FREIGHT: "Emergency Fixed Freight",
        SHOW_BACKORDERS_ON_PART_DETAIL: "Show Backorders on Part Detail",
        SHOW_DIAGRAMS_BUTTON: "Show Diagrams Button",
    },
    BREAKPOINTS: {
        XS: 480,
        SM: 768,
        MD: 992,
        LG: 1200
    },
    MLA_RETURNS_BLACK_SETTINGS_KEYS: {
        ACTIVE: "MLA_RETURNS_BLACKOUT_ACTIVE",
        START_DATE: "MLA_RETURNS_BLACKOUT_START_DATE",
        END_DATE: "MLA_RETURNS_BLACKOUT_END_DATE",
        MESSAGE: "MLA_RETURNS_BLACKOUT_HTML",
    },
    MLA_ORDERS_BLACK_SETTINGS_KEYS: {
        START_DATE: "MLA_ORDERS_BLACKOUT_START_DATE",
        END_DATE: "MLA_ORDERS_BLACKOUT_END_DATE",
        MESSAGE: "MLA_ORDERS_BLACKOUT_MESSAGE",
        NEWS_STORY: "MLA_ORDERS_BLACKOUT_NEWS_STORY"
    },
    MLA_BANNER_SETTINGS:{
        START_DATE: "BANNER_START_DATE",
        END_DATE: "BANNER_END_DATE",
        MESSAGE: "BANNER_MESSAGE",
        HEADER: "BANNER_HEADER",
        COST_CENTERS: "BANNER_COST_CENTERS"
    },
    ORDERSEARCH_DEALERCODE_BATCHSIZE: 100,
    MLE_ORDER_ITEM_MAX_QUANTITY: 100,
    MLE_ORDER_ITEM_MAX_COST: 5000
});
